import request from '@/utils/request'
// 登陆
export function login(params) {
  return request({
    url: '/auth/login',
    method: 'post',
    data: params
  })
}
// 获取登陆用户得信息（权限数据）
export function getInfo() {
  return request({
    url: '/auth/user/getInfo',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js